import Provider from "./src/utils/context"

export const wrapRootElement = Provider
